class Config {
  public apiUrl: string;
  public env: 'local' | 'ui-test' | 'dev' | 'dev2' | 'test' | 'live';
  public ssoClientUrl: string;
  public teliaWebUrl: string;
  public teliaWebSelfServiceUrl: string;
  public teliaShopUrl: string;
  public webSearchApiUrl: string;
  public brandFreeWebUrl: string;
  public elionWebUrl: string;
  public mobileServicesUrl: string;
  public partnerOffersUrlB2C: string;
  public partnerOffersUrlB2B: string;
  public campaignsUrlB2C: string;
  public campaignsUrlB2B: string;
  public componentTier: string;
  public componentApiBaseUrl: string;
  public roamingDayPackageTermsB2CEst: string;
  public roamingDayPackageTermsB2BEst: string;
  public roamingDayPackageTermsB2CRus: string;
  public roamingDayPackageTermsB2BRus: string;
  public dealerNewsUrl: string;
  public teliaTvUrl: string;
  public credentialsAllowed: boolean;
  public argosCustomerViewUrl: string;
  public devHostAliasNames: string[];
  public externalPaths: string[];
  public enableLabelStatistics: boolean;
  public commonApiUrl: string;
  public optimizelySdkKey: string;
  public geopankUrl: string;

  public initialize(initialConfig: InitialConfig) {
    this.apiUrl = initialConfig.apiUrl;
    this.env = initialConfig.env;
    this.ssoClientUrl = initialConfig.ssoClientUrl;
    this.teliaWebUrl = initialConfig.teliaWebUrl;
    this.teliaWebSelfServiceUrl = initialConfig.teliaWebSelfServiceUrl;
    this.teliaShopUrl = initialConfig.teliaShopUrl;
    this.webSearchApiUrl = initialConfig.webSearchApiUrl;
    this.brandFreeWebUrl = initialConfig.brandFreeWebUrl;
    this.elionWebUrl = initialConfig.elionWebUrl;
    this.mobileServicesUrl = initialConfig.mobileServicesUrl;
    this.partnerOffersUrlB2C = initialConfig.partnerOffersUrlB2C;
    this.partnerOffersUrlB2B = initialConfig.partnerOffersUrlB2B;
    this.campaignsUrlB2C = initialConfig.campaignsUrlB2C;
    this.campaignsUrlB2B = initialConfig.campaignsUrlB2B;
    this.componentTier = initialConfig.componentTier;
    this.componentApiBaseUrl = initialConfig.componentApiBaseUrl;
    this.roamingDayPackageTermsB2CEst = initialConfig.roamingDayPackageTermsB2CEst;
    this.roamingDayPackageTermsB2BEst = initialConfig.roamingDayPackageTermsB2BEst;
    this.roamingDayPackageTermsB2CRus = initialConfig.roamingDayPackageTermsB2CRus;
    this.roamingDayPackageTermsB2BRus = initialConfig.roamingDayPackageTermsB2BRus;
    this.dealerNewsUrl = initialConfig.dealerNewsUrl;
    this.teliaTvUrl = initialConfig.teliaTvUrl;
    this.credentialsAllowed = initialConfig.credentialsAllowed;
    this.argosCustomerViewUrl = initialConfig.argosCustomerViewUrl;
    this.devHostAliasNames = initialConfig.devHostAliasNames;
    this.externalPaths = initialConfig.externalPaths;
    this.enableLabelStatistics = initialConfig.enableLabelStatistics;
    this.commonApiUrl = initialConfig.commonApiUrl;
    this.optimizelySdkKey = initialConfig.optimizelySdkKey;
    this.geopankUrl = initialConfig.geopankUrl;
  }
}

export default new Config();
